module.exports = __webpack_public_path__ + "static/media/rubiks_cube.cb429c85.svg";